<div class="position-relative mb-4">
  @if (article) {
    <img
      [src]="article.image_url"
      alt=""
      class="object-fit-cover w-100"
      height="300"
    />
  } @else {
    <div
      class="object-fit-cover"
      style="height: 300px; background-color: #f0f0f0"
    ></div>
  }

  <div class="position-absolute bottom-0 start-50 translate-middle-x">
    @if (article) {
      <h1 class="fw-normal text-bg-dark px-5 py-2">
        {{ article.title }}
      </h1>
    } @else {
      <div
        class="text-bg-dark text-center mb-2"
        style="width: 600px; height: 60px"
      ></div>
    }
  </div>
</div>

<div class="container">
  <div class="row">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      @if (article) {
        <h5 class="text-center mb-3">
          {{ article.date | date: "d 'de' MMMM, y" }}
        </h5>
      } @else {
        <div class="text-center">
          <h5 class="placeholder-glow">
            <span class="placeholder col-4"></span>
          </h5>
        </div>
      }

      @if (article) {
        <app-dynamic-content-viewer [content]="article.content" />
      } @else {
        <div class="text-center mb-3">
          <h6 class="placeholder-glow">
            <span class="placeholder col-12"></span>
            <span class="placeholder col-12"></span>
            <span class="placeholder col-12"></span>
            <span class="placeholder col-12"></span>
            <span class="placeholder col-12"></span>
          </h6>
        </div>
      }

      <hr />

      <div class="d-flex justify-content-between">
        @if (article) {
          <div>
            @for (subcategory of article.subcategories; track subcategory) {
              <span class="badge bg-secondary me-2">
                {{ getSubcategoryName(subcategory) }}
              </span>
            }
          </div>
        } @else {
          <div class="container p-0">
            <div class="row">
              <div class="placeholder-glow">
                <span class="placeholder col-2 me-2"></span>
                <span class="placeholder col-2"></span>
              </div>
            </div>
          </div>
        }
      </div>

      <hr />
    </div>
    <div class="col-md-3"></div>
  </div>

  <h2 class="text-center">Otras noticias</h2>

  <div class="row g-3 justify-content-center mt-4">
    @for (article of articles; track article) {
      <div class="col-md-3">
        <a [routerLink]="['/articulo', article.id]">
          <div class="card text-bg-dark" style="min-height: 300px">
            <img
              [src]="article.image_url"
              class="card-img object-fit-cover"
              height="180"
              alt=""
            />
            <div class="p-2">
              <h5 class="card-title">{{ article.title }}</h5>
              <p class="card-text">
                <i class="bi bi-clock"></i>
                {{ article.date | date: 'dd/MM/yyyy' }}
              </p>
            </div>
          </div>
        </a>
      </div>
    } @empty {
      @for (placeholder of [1, 2, 3, 4]; track placeholder) {
        <div class="col-md-3 placeholder-glow">
          <span class="placeholder w-100" style="height: 280px"></span>
        </div>
      }
    }
  </div>
</div>
